import { AlertService } from 'src/app/shared/toast/alert.service';
import { LicenseLiabilityService } from './../license-liability.service';
import { Component, OnInit, NgZone, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomLoadingService } from 'src/app/shared/custom-loading/custom-loading.service';
import * as moment from 'moment';
import { AppSettingService } from 'src/app/services/app-setting.service';
import { TranslateService } from '@ngx-translate/core';
declare var $: any;
declare var myExtObject: any;
@Component({
  selector: 'app-add-license',
  templateUrl: './add-license.component.html',
  styleUrls: ['./add-license.component.css']
})
export class AddLicenseComponent implements OnInit {
  licenseForm: FormGroup
  license: any
  dateFormat = ""
  error: any
  title: any = "NewLicense"
  public attachementList: any = [];
  public licenseAttachementList: any = [];
  @ViewChild("fileInput") fileInput;
  public uploadedFileName: string = "";
  public uploadedFileType: string = "";
  public uploadedFileSize: number = 0;
  public fileToUpload: any;
  public attachmentID: number;
  fileNameArray: any = [];
  public deletedAttachmentIds: string = "";
  public deleteAttachmentId: string;
  public attachemtId: string = "";
  public deleteAttachmentName: string;
  public deleteAttachmentNames: string = "";
  uploadedFileError: any = ""
  licenseId: any = 0
  licenseType: any = []
  public fileArray = [];
  constructor(
    private _ngZone: NgZone,
    private formBuilder: FormBuilder,
    private service: LicenseLiabilityService,
    private loadingService: CustomLoadingService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private translateService: TranslateService,
    private alertService: AlertService
  ) {
    this.activatedRoute.params.subscribe(params => {

      this.licenseId = params["id"] || 0

    });
    window["angularComponentRef"] = { component: this, zone: _ngZone };
    this.licenseForm = this.formBuilder.group({
      Id: [this.licenseId],
      Name: ['', Validators.compose([Validators.required])],
      Type: ['', Validators.compose([Validators.required])],
      Number: ['', Validators.compose([Validators.required])],
      ExpiryDate: ['', Validators.compose([Validators.required])],
      State: ['', Validators.compose([Validators.required])],
    });
    this.getLicenseType();
  }

  ngOnInit(): void {

    myExtObject.bindCalendar();
    if (this.licenseId > 0)
      this.getLicense(this.licenseId);

  }
  setDate(date: any) {

    this.licenseForm.controls["ExpiryDate"].setValue(date);


  }
  getLicense(licenseId: any) {
    this.loadingService.show();
    this.service.getLicense(licenseId).subscribe(res => {

      this.license = res;
      if (this.license) {
        this.licenseForm.controls["Id"].setValue(this.license.LicenseId)
        this.licenseForm.controls["Name"].setValue(this.license.LicenseName)
        this.licenseForm.controls["ExpiryDate"].setValue(moment(this.license.LicenseExpiryDate).format("MM/DD/YYYY"))
        this.licenseForm.controls["Type"].setValue(this.license.LicenseType)
        this.licenseForm.controls["State"].setValue(this.license.LicenseState)
        this.licenseForm.controls["Number"].setValue(this.license.LicenseNumber)

      }
      this.licenseAttachementList = res.Attachments

    }, (error) => {
      this.error = this.translateService.instant("GenericError")
      this.loadingService.hide();
    }, () => {
      this.loadingService.hide();
    });

  }
  getLicenseType() {

    this.service.getLicenseTypes().subscribe(res => {
      this.licenseType = res;
    }
      , () => { }, () => { }
    )

  }
  Addlicense(model: any) {

    let obj: any = []
    this.attachementList.forEach(item => {
      var newObj = {
        FileName: item.FileName,
        FileType: item.FileExtension,
        AttachmentData: item.Attachment
      }
      obj.push(newObj);
    });

    model.Attachments = obj;
    model.DeletedAttachmentIds = this.deletedAttachmentIds || "";
    if (this.licenseForm.valid) {
      this.loadingService.show();
      this.alertService.success(this.translateService.instant("RecordSaved"), { keepAfterRouteChange: true })

      this.service.addLicense(model).subscribe(res => {
        this.router.navigate(["/managepractice/licenseandliability/licenses"]);

      }, (error) => {
        this.alertService.error(this.translateService.instant("GenericError"), { keepAfterRouteChange: true })


        this.loadingService.hide();
      }, () => {
        this.loadingService.hide();
      })
    }
  }
  drag() {
    $('#dropZone').addClass('Drop');
  }

  dragLeave() {
    $('#dropZone').removeClass('Drop');
  }
  addFile(): void {
    this.dragLeave();
    let fi = this.fileInput.nativeElement;
    for (let i = 0; i < fi.files.length; i++) {
      var file = fi.files[i];

      var fileDetail = file.name.split('.');
      var fileTypeCheck = fileDetail[fileDetail.length - 1];
      if (fileTypeCheck.toLowerCase() == 'pdf' || file.type.indexOf('image')>-1) {
        if (this.checkUploadedFile(file)) {
          this.loadingService.show();
          var fileName = file.name;
          var arrName = fileName.split('.');
          var fileType = '.' + arrName[arrName.length - 1];
          var fileSize = file.size;
          this.uploadedFileName = fileName;

          this.getBase64(file, fileName, fileType, fileSize);
        }
      }
      else {
        this.alertService.error(
          this.translateService.instant("Common.PdfandImage"))
          
      }
    }
  }

  getBase64(file, fileName, fileType, fileSize) {
    var result;
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      result = reader.result;
    };
    reader.onerror = function (error) {
      result = error;
    };
    setTimeout(() => {
      this.setFileInput(result, fileName);
    }, 2500);
  }

  setFileInput(fileInput: any, fileName) {
    var attachmentDetails: any = []
    this.fileArray = fileInput.split(',');
    attachmentDetails.Attachment = this.fileArray[1];
    attachmentDetails.FileName = fileName;
    this.fileNameArray = fileName.split('.');
    attachmentDetails.FileExtension = "." + this.fileNameArray[this.fileNameArray.length - 1];
    this.attachementList.push(attachmentDetails);


    this.loadingService.hide();
  }

  checkUploadedFile(file) {
    try {
      if (AppSettingService.RequestFileTypeRegEx.exec(file.name)) {
        this.uploadedFileError = AppSettingService.RequestFileTypeError;
      }
      else if (file.size > AppSettingService.maxFileSize) {
        this.uploadedFileError = AppSettingService.userFileSizeError;
      }

      else {
        this.uploadedFileError = "";
        return true;
      }
      return false;

    } catch (error) {
      throw Error(error);
    }
  }
  removeUnsavedAttachent(attachemtname: string) {

    $("#delete-attachment-modal").modal("show");
    this.deleteUnsavedAttachments(parseInt(attachemtname));
  }

  // public msg :number= 1;
  deleteUnsavedAttachments(attachmentid: number) {
    const index: number = this.attachementList.indexOf[attachmentid];

    if (index !== -1) {
      this.attachementList.splice(index, 1);
    }
  }
  updateBenefitPlanAttachments() {
    $("#delete-attachment-modal").modal("hide");
    if (this.deleteAttachmentId != undefined) {
      this.deletedAttachmentIds += (this.deletedAttachmentIds == "") ? (this.deleteAttachmentId) : ("," + this.deleteAttachmentId);
      $(".divAttachmentId" + this.deleteAttachmentId).remove();
    }

  }

  deleteAttach(attachmentId: string) {

    $("#delete-attachment-modal").modal("show");
    this.deleteAttachmentId = attachmentId;

  }
}


